import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(value: number, currency = 'RSD'): string {
  return new Intl.NumberFormat('sr-RS', { maximumFractionDigits: 0 }).format(Math.round(value)) + (currency ? ` ${currency}` : '')
}
